/**
 * Strip common Markdown syntax to readable plain text for clipboard copy.
 * Not a full CommonMark parser — good enough for assistant reply paste.
 */
export function markdownToPlainText(markdown: string): string {
  let text = markdown.replace(/\r\n?/g, "\n");

  // Fenced code blocks → keep inner code
  text = text.replace(/```[^\n]*\n?([\s\S]*?)```/g, (_m, code: string) =>
    code.replace(/\n$/, ""),
  );

  // Images → alt text
  text = text.replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1");

  // Links → label
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");

  // Headings
  text = text.replace(/^#{1,6}\s+/gm, "");

  // Blockquotes
  text = text.replace(/^>\s?/gm, "");

  // Unordered / ordered list markers
  text = text.replace(/^(\s*)[-*+]\s+/gm, "$1");
  text = text.replace(/^(\s*)\d+\.\s+/gm, "$1");

  // Horizontal rules
  text = text.replace(/^(\s*)([-*_]){3,}\s*$/gm, "");

  // Bold / italic / strikethrough (repeat for nesting)
  for (let i = 0; i < 3; i++) {
    text = text
      .replace(/\*\*([^*]+)\*\*/g, "$1")
      .replace(/__([^_]+)__/g, "$1")
      .replace(/\*([^*]+)\*/g, "$1")
      .replace(/_([^_]+)_/g, "$1")
      .replace(/~~([^~]+)~~/g, "$1");
  }

  // Inline code
  text = text.replace(/`([^`]+)`/g, "$1");

  return text.replace(/\n{3,}/g, "\n\n").trim();
}
